import { memo } from "react";
import styled from "styled-components";
import Page from "components/page/Page";
import PageWrapper from "components/pageWrapper/PageWrapper";
import Helmet from "components/headHelmet/HeadHelmet";
import GreenButton from "components/greenButton/GreenButton";
import SmartLink from "components/smartLink/SmartLink";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "hooks";
import { languageSelector } from "selectors/uiSelectors";
import { localizePath } from "utility/languageUtility";

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 80px 20px;
  gap: 20px;
`;

const Code = styled.h1`
  font-size: 6rem;
  font-weight: 700;
  color: #28c604;
  line-height: 1;
  margin: 0;

  @media only screen and (max-width: 768px) {
    font-size: 4rem;
  }
`;

const Heading = styled.h2`
  font-size: 1.6rem;
  font-weight: 600;
  color: #111;
  margin: 0;

  @media only screen and (max-width: 768px) {
    font-size: 1.3rem;
  }
`;

const Body = styled.p`
  font-size: 1rem;
  color: #666;
  max-width: 480px;
  margin: 0;
  line-height: 1.6;
`;

const NotFoundPage = () => {
  const { t } = useTranslation("common");
  const language = useAppSelector(languageSelector);

  return (
    <>
      <Helmet>
        <title>{t("notFound.metaTitle")}</title>
      </Helmet>
      <Page collapsedView={true}>
        <PageWrapper>
          <Container>
            <Code>404</Code>
            <Heading>{t("notFound.heading")}</Heading>
            <Body>{t("notFound.body")}</Body>
            <SmartLink to={localizePath("/", language)}>
              <GreenButton disabled={false}>{t("notFound.cta")}</GreenButton>
            </SmartLink>
          </Container>
        </PageWrapper>
      </Page>
    </>
  );
};

export default memo(NotFoundPage);
